import * as yup from 'yup';
import { Step } from '../../CharitableGiving.meta';
import { OptionType } from '../../../../../CommonComponents/OPL/Select/BaseSelect/types';

export const STEP_ID: Step = 'charityName';

export interface FormValues {
  charityName: OptionType<string> | null;
}

export const charityNameValidation = yup
  .object()
  .shape({
    label: yup.string().required(),
    value: yup.string().required(),
  })
  .nullable()
  .required("Please, enter the charity's name");

export const validation = yup.object().shape({
  charityName: charityNameValidation,
});
